export const DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_PATH = '/simuladorempresas';
export const DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_MKT_PATH = '/simulador-empresas-mkt';
